var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.207,
    height: 15.311,
    viewBox: "0 0 15.207 15.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close-13",
    d: "M7.428,21.176a1.46,1.46,0,0,0,2.065,0L14.3,16.367l4.809,4.809a1.46,1.46,0,1,0,2.065-2.065L16.367,14.3l4.809-4.809a1.46,1.46,0,1,0-2.065-2.065L14.3,12.237,9.493,7.428A1.46,1.46,0,1,0,7.428,9.493L12.237,14.3,7.428,19.111A1.46,1.46,0,0,0,7.428,21.176Z",
    transform: "translate(-6.646 -6.646)",
    fill: "#b2b2b2",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d221a995c778ad73854ba731339a0f19.svg";
export { ForwardRef as ReactComponent };